import { endOfMonth, endOfYear, startOfMonth, startOfYear, sub } from "date-fns"
import { formatDateQueryParam } from "../services"
import { Period } from "../types"
import { assertNever } from "./assertNever"

export interface DateRange {
  startDate: string
  endDate: string
}

export const getPeriodDateRange = (
  period: Period,
  today = new Date(),
): DateRange => {
  const isJanuary = today.getMonth() === 0

  let startDate: Date | null
  let endDate: Date | null

  switch (period) {
    case Period.YEAR_TO_DATE:
      startDate = startOfYear(today)
      endDate = today
      break
    case Period.YEAR_ELAPSED_MONTH:
      startDate = startOfYear(today)
      endDate = isJanuary ? today : endOfMonth(sub(today, { months: 1 }))
      break
    case Period.CURRENT_MONTH:
      startDate = startOfMonth(today)
      endDate = today
      break
    case Period.LAST_MONTH:
      startDate = startOfMonth(sub(today, { months: 1 }))
      endDate = endOfMonth(sub(today, { months: 1 }))
      break
    case Period.PREVIOUS_YEAR:
      startDate = startOfYear(sub(today, { years: 1 }))
      endDate = endOfYear(sub(today, { years: 1 }))
      break
    case Period.TWO_YEARS_AGO:
      startDate = startOfYear(sub(today, { years: 2 }))
      endDate = endOfYear(sub(today, { years: 2 }))
      break
    case Period.LAST_3_MONTHS:
      startDate = startOfMonth(sub(today, { months: 3 }))
      endDate = endOfMonth(sub(today, { months: 1 }))
      break
    case Period.LAST_4_MONTHS:
      startDate = startOfMonth(sub(today, { months: 4 }))
      endDate = endOfMonth(sub(today, { months: 1 }))
      break
    case Period.LAST_12_MONTHS:
      startDate = startOfMonth(sub(today, { months: 12 }))
      endDate = endOfMonth(sub(today, { months: 1 }))
      break
    default:
      return assertNever(
        period,
        {
          startDate: "",
          endDate: "",
        },
        "getPeriodDateRange.ts",
      )
  }

  return {
    startDate: formatDateQueryParam(startDate),
    endDate: formatDateQueryParam(endDate),
  }
}
